import { render, staticRenderFns } from "./Competitors.vue?vue&type=template&id=a581619c&scoped=true&"
import script from "./Competitors.vue?vue&type=script&lang=js&"
export * from "./Competitors.vue?vue&type=script&lang=js&"
import style0 from "./Competitors.vue?vue&type=style&index=0&id=a581619c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a581619c",
  null
  
)

export default component.exports